import { match } from 'ts-pattern'
import i18next from 'i18next'
import type { RegularHolidayMutator } from '@/lib/entity/regular_holiday'
import type { Converter } from '@/lib/converter/entityFormatter'
import { asModifiedField } from '@/lib/converter/entityFormatter'

type RegularHolidaySchema = RegularHolidayMutator['merged']

export const RegularHolidayConverter: Converter<RegularHolidaySchema> = {
  icon: () => i18next.t('stages.icon.regular_holiday'),
  title: () => i18next.t('stages.table.regular_holiday'),
  subTitle: async (merged) =>
    i18next.t(`dayOfWeek.${merged.day_of_week}`) || i18next.t('ui.common.inputting'),
  modifiedFields: (modified, column) => {
    console.log(column)
    const label = i18next.t(`stages.labels.regular_holiday.${column}`)
    return match(column)
      .with('year', 'day_of_week', 'day_off', (column) => {
        if (column === 'day_of_week') {
          return asModifiedField(label, i18next.t(`dayOfWeek.${modified[column]}`))
        }
        return asModifiedField(label, modified[column]!)
      })
      .with('id', () => undefined)
      .exhaustive()
  }
}
